import styled from 'styled-components';

export const StyledSideButton = styled.div<{
  $isNext?: boolean;
}>(({
  $isNext,

  theme: {
    indents,
  },
}) => ({
  display: 'inline-block',
  verticalAlign: 'bottom',

  [$isNext ? 'marginLeft' : 'marginRight']: indents.INDENT_2,
}));

export const StyledSideButtonLink = styled.button<{
  isDisabled: boolean;
}>(({
  isDisabled,

  theme: {
    colors,
    fonts,
    indents,
  },
}) => ({
  ...fonts.FONT_SMALL,
  paddingTop: indents.INDENT_1,
  paddingBottom: indents.INDENT_1,
  paddingLeft: 0,
  paddingRight: 0,
  cursor: isDisabled ? 'default' : 'pointer',
  color: isDisabled ? colors.NEUTRAL_INACTIVE : colors.ACTION_DEFAULT,
  background: 'transparent',
  margin: 0,
  outline: 'none',
  border: 'none',
  textdecoration: 'none',

  ':hover': isDisabled ? undefined : {
    color: colors.ACTION_HOVER,
  },

  ':active': isDisabled ? undefined : {
    color: colors.ACTION_PRESSED,
  },
}));
